module.exports = __webpack_public_path__ + "img/img_left@2x.8c055302.png";